const actions = {
    CREATE_DEALER: "CREATE_DEALER",
    CREATE_DEALER_SUCCESS: "CREATE_DEALER_SUCCESS",
    CREATE_DEALER_FAILED: "CREATE_DEALER_FAILED",

    GET_DEALER_LIST: "GET_DEALER_LIST",
    GET_DEALER_LIST_SUCCESS: "GET_DEALER_LIST_SUCCESS",
    GET_DEALER_LIST_FAILED: "GET_DEALER_LIST_FAILED",

    MODIFY_DEALER: "MODIFY_DEALER",
    MODIFY_DEALER_SUCCESS: "MODIFY_DEALER_SUCCESS",
    MODIFY_DEALER_FAILED: "MODIFY_DEALER_FAILED",

    RESET_MESSAGE: 'RESET_MESSAGE',

    createDealer: (data) => ({
        type: actions.CREATE_DEALER,
        payload: { data },
    }),
    createDealerSuccess: (message) => ({
        type: actions.CREATE_DEALER_SUCCESS,
        message,
    }),
    createDealerError: (error) => ({
        type: actions.CREATE_DEALER_FAILED,
        error,
    }),


  getDealerList: (data = {}) => ({
    type: actions.GET_DEALER_LIST,
    payload: {
        data,
    },
}),
    getDealerListSuccess: (data) => ({
        type: actions.GET_DEALER_LIST_SUCCESS,
        payload: { data },
    }),
    getDealerListError: (error) => ({
        type: actions.GET_DEALER_LIST_FAILED,
        error,
    }),

    modifyDealer: (data) => ({
        type: actions.MODIFY_DEALER,
        payload: {
            data,
        },
    }),

    modifyDealerSuccess: (message) => ({
        type: actions.MODIFY_DEALER_SUCCESS,
        message,
    }),

    modifyDealerError: (error) => ({
        type: actions.MODIFY_DEALER_FAILED,
        error,
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),
};
export default actions;
